import './MapBuildingDrawer.scss';

import {ArrowRightOutlined, BankOutlined, RightOutlined} from '@ant-design/icons';
import {Button} from 'antd';
import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import AntButton from '../../../components/AntButton/AntButton';
import AntDivider from '../../../components/Divider/Divider';
import ObjectImageCard from '../../../components/DrawerComponents/DrawerObjectHeader/ObjectImageCard';
import DrawerSectionCoverageProgress from '../../../components/DrawerComponents/DrawerSectionCoverageProgress/DrawerSectionCoverageProgress';
import DrawerSectionDataCollector from '../../../components/DrawerComponents/DrawerSectionDataCollector/DrawerSectionDataCollector';
import ObjectUtilitiesDrawerSection from '../../../components/DrawerComponents/DrawerSectionObjectUtilities/ObjectUtilitiesDrawerSection';
import * as localizationKeys from '../../../consts/localization/localizationKeys';
import * as routePaths from '../../../consts/route/routePaths';
import appRouterService from '../../../services/app/appRouterService';
import {getLocalizedStrings} from '../../../services/localization/localizationService';
import {setBuildingProfile} from '../../../state/ducks/buildings';
import {makeSelectBuildingProfile, makeSelectBuildingProfileRoomsCount} from '../../../state/selectors/buildings';
import {dispatch} from '../../../state/store';

const mapStateToProps = createStructuredSelector({
    buildingProfile: makeSelectBuildingProfile(),
    roomsCount: makeSelectBuildingProfileRoomsCount(),
});

const MapBuildingDrawerContent = ({buildingProfile, mobile = false, panelRef, onViewDetails}) => {
    const {uspds = [], roomsCount = 0, successPercentage, failurePercentage} = buildingProfile || {};

    const efficiencyPercentage = +successPercentage + +failurePercentage;

    const localizedStrings = getLocalizedStrings();

    const forwardToCurrentOrganizationPage = () => {
        appRouterService.forwardToBuildingProfilePage(String(buildingProfile.buildingID));
    };

    useEffect(() => {
        return () => {
            dispatch(setBuildingProfile(null));
        };
    }, []);

    if (mobile) {
        return (
            <div className='map-building-mobile-content' ref={panelRef}>
                <div className='map-building-mobile-layout'>
                    <ObjectImageCard objectData={buildingProfile} roomsCount={roomsCount} mobile />
                    <Button
                        type='primary'
                        className='map-building-mobile-primary'
                        disabled={!buildingProfile?.buildingID}
                        onClick={onViewDetails}
                    >
                        <span>{localizedStrings[localizationKeys.BUTTON_TEXT_MORE]}</span>
                        <ArrowRightOutlined aria-hidden />
                    </Button>
                    {buildingProfile?.organizationName && (
                        <a
                            className='map-building-mobile-organization'
                            href={`${routePaths.ORGANIZATION_PAGE}/${buildingProfile.organizationID}`}
                        >
                            <span className='map-building-mobile-organization-icon' aria-hidden>
                                <BankOutlined />
                            </span>
                            <span className='map-building-mobile-organization-text'>
                                <span className='map-building-mobile-organization-label'>
                                    {localizedStrings[localizationKeys.ROOMER_OBJECTS_PAGE_ORGANIZATION_NAME]}
                                </span>
                                <span className='map-building-mobile-organization-name'>
                                    {buildingProfile.organizationName}
                                </span>
                            </span>
                            <RightOutlined aria-hidden />
                        </a>
                    )}
                    <section className='map-building-mobile-section'>
                        <h3>{localizedStrings[localizationKeys.SETTINGS_TAB_TITLE_COUNTERS]}</h3>
                        <ObjectUtilitiesDrawerSection mobile />
                    </section>
                    <section className='map-building-mobile-section'>
                        <DrawerSectionCoverageProgress
                            averageStatusPercentage={efficiencyPercentage}
                            successPercentage={successPercentage}
                            failurePercentage={failurePercentage}
                            mobile
                        />
                    </section>
                    <DrawerSectionDataCollector uspds={uspds} mobile />
                </div>
            </div>
        );
    }

    return (
        <div className='map-building-drawer-content flex flex-col w-full bg-white pb-6 min-h-full'>
            <div className='flex flex-col'>
                <ObjectImageCard
                    className='map-building-drawer-image-card'
                    roomsCount={roomsCount}
                    objectData={buildingProfile}
                />
                <AntDivider className='mt-4 mb-1.5' />
                <ObjectUtilitiesDrawerSection />
                <AntDivider />
            </div>

            <div className='flex flex-col mt-4'>
                <DrawerSectionDataCollector uspds={uspds} />
            </div>

            <div className='mt-auto flex flex-col w-full pt-4'>
                <DrawerSectionCoverageProgress
                    averageStatusPercentage={efficiencyPercentage}
                    successPercentage={successPercentage}
                    failurePercentage={failurePercentage}
                />

                <AntButton
                    className={`py-4 font-medium text-16 rounded-6 shadow-sm mx-auto mt-5`}
                    onClick={forwardToCurrentOrganizationPage}
                    primary
                >
                    {localizedStrings[localizationKeys.BUTTON_TEXT_MORE]}
                </AntButton>
            </div>
        </div>
    );
};

export default connect(mapStateToProps)(MapBuildingDrawerContent);
